import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Settings, MessageSquare, Heart, Share2, Rss, Instagram, Twitter, Facebook, Youtube, Linkedin, BookOpen, RefreshCw } from 'lucide-react';
import { WidgetCard } from '../ui/WidgetCard';
// TypeScript interfaces
interface SocialTabProps {
  label: string;
  icon: string | null;
  active?: boolean;
  onClick: () => void;
}
interface BookCover {
  title: string;
  image: string;
}
interface SocialPostProps {
  platform: string;
  time: string;
  content: string;
  likes: number;
  comments: number;
  bookCover?: BookCover | null;
  showInRealContext?: boolean;
}
export function SocialFeedWidget() {
  const [activeFilter, setActiveFilter] = useState('all');
  const navigate = useNavigate();
  const socialPosts = [{
    platform: 'instagram',
    time: '2 hours ago',
    content: 'New chapter coming soon! 📚✨ #writing #novel',
    likes: 24,
    comments: 8,
    bookCover: {
      title: 'The Garden Between Clouds',
      image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/67FfJDXox9973Yr212r9mt/IMG_0033.webp'
    }
  }, {
    platform: 'twitter',
    time: '4 hours ago',
    content: 'Today is a good day for writing. Coffee is ready and ideas are flowing! ☕️',
    likes: 12,
    comments: 3
  }, {
    platform: 'facebook',
    time: '1 day ago',
    content: 'Thank you all for your support! My new book is taking shape.',
    likes: 45,
    comments: 15
  }, {
    platform: 'instagram',
    time: '5 hours ago',
    content: 'Found inspiration during a walk in the park 🌳 #creativewriting',
    likes: 31,
    comments: 7
  }, {
    platform: 'twitter',
    time: '1 day ago',
    content: 'Who are your favorite authors? Looking for new weekend reads! 📖',
    likes: 18,
    comments: 22
  }, {
    platform: 'facebook',
    time: '2 days ago',
    content: 'I just finished reading an extraordinary book that changed my perspective on life.',
    likes: 67,
    comments: 13,
    bookCover: {
      title: 'Think Like A Boss',
      image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/mH3hvE4SdWb6hacSUtkerR/IMG_0029.webp'
    }
  }, {
    platform: 'instagram',
    time: '3 days ago',
    content: 'Night writing session. The best ideas come when everything is quiet. 🌙✍️ #bookauthor',
    likes: 42,
    comments: 5
  }, {
    platform: 'twitter',
    time: '2 days ago',
    content: 'Reader feedback: the most rewarding part of being a writer. Thank you for your messages!',
    likes: 29,
    comments: 8
  }, {
    platform: 'facebook',
    time: '4 days ago',
    content: 'Announcement: my next book will be released next month! Stay tuned for more details.',
    likes: 89,
    comments: 34,
    bookCover: {
      title: 'The Mist Forest',
      image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/ohuR3qoocQgeTShLBv1x3x/IMG_0027.webp'
    }
  }];
  const handleManageChannelsClick = () => {
    navigate('/profile?tab=social-channels');
  };
  return <WidgetCard title="Your Social Feed" actionArea={<button onClick={handleManageChannelsClick} className="flex items-center space-x-2 text-sm bg-[#376770] text-white px-3.5 py-1.5 rounded-md hover:bg-[#2d5459] transition-colors" data-id="element-120">
          <Settings size={14} data-id="element-121" />
          <span data-id="element-122">Manage Channels</span>
        </button>} contentClassName="p-0" data-id="element-119">
      <div className="flex flex-col" data-id="element-123">
        {/* Filters */}
        <div className="border-b border-gray-100" data-id="element-124">
          <div className="flex items-center py-3.5 overflow-x-auto scrollbar-hide" data-id="element-125">
            <div className="flex space-x-2" data-id="element-126">
              <button onClick={() => setActiveFilter('all')} className={`px-3 sm:px-4 py-1.5 text-sm font-medium ${activeFilter === 'all' ? 'bg-[#C6D6AB] text-[#164149]' : 'text-gray-600 hover:bg-[#EFF2F1]'} rounded-md transition-colors whitespace-nowrap`} data-id="element-127">
                All
              </button>
              <button onClick={() => setActiveFilter('instagram')} className={`px-3 sm:px-4 py-1.5 text-sm font-medium ${activeFilter === 'instagram' ? 'bg-[#C6D6AB] text-[#164149]' : 'text-gray-600 hover:bg-[#EFF2F1]'} rounded-md transition-colors whitespace-nowrap flex items-center space-x-1.5`} data-id="element-128">
                <Instagram size={14} data-id="element-129" />
                <span data-id="element-130">Instagram</span>
              </button>
              <button onClick={() => setActiveFilter('twitter')} className={`px-3 sm:px-4 py-1.5 text-sm font-medium ${activeFilter === 'twitter' ? 'bg-[#C6D6AB] text-[#164149]' : 'text-gray-600 hover:bg-[#EFF2F1]'} rounded-md transition-colors whitespace-nowrap flex items-center space-x-1.5`} data-id="element-131">
                <Twitter size={14} data-id="element-132" />
                <span data-id="element-133">Twitter</span>
              </button>
              <button onClick={() => setActiveFilter('facebook')} className={`px-3 sm:px-4 py-1.5 text-sm font-medium ${activeFilter === 'facebook' ? 'bg-[#C6D6AB] text-[#164149]' : 'text-gray-600 hover:bg-[#EFF2F1]'} rounded-md transition-colors whitespace-nowrap flex items-center space-x-1.5`} data-id="element-134">
                <Facebook size={14} data-id="element-135" />
                <span data-id="element-136">Facebook</span>
              </button>
            </div>
          </div>
        </div>
        {/* Posts grid */}
        <div className="py-5" data-id="element-137">
          <div style={{
          columnCount: 3,
          columnGap: '1rem',
          maxWidth: '100%'
        }} className="sm:columns-2 md:columns-3 gap-4" data-id="element-138">
            {socialPosts.filter(post => activeFilter === 'all' || post.platform === activeFilter).map((post, index) => <div key={index} style={{
            breakInside: 'avoid',
            marginBottom: '1rem',
            display: 'inline-block',
            width: '100%'
          }} data-id="element-139">
                  <SocialPost platform={post.platform} time={post.time} content={post.content} likes={post.likes} comments={post.comments} bookCover={post.bookCover} data-id="element-140" />
                </div>)}
          </div>
        </div>
      </div>
    </WidgetCard>;
}
function SocialPost({
  platform,
  time,
  content,
  likes,
  comments,
  bookCover = null,
  showInRealContext = false
}: SocialPostProps) {
  const getPlatformIcon = (platform: string) => {
    switch (platform) {
      case 'instagram':
        return <Instagram size={16} className="text-pink-500" data-id="element-141" />;
      case 'twitter':
        return <Twitter size={16} className="text-blue-500" data-id="element-142" />;
      case 'facebook':
        return <Facebook size={16} className="text-blue-600" data-id="element-143" />;
      case 'youtube':
        return <Youtube size={16} className="text-red-500" data-id="element-144" />;
      case 'linkedin':
        return <Linkedin size={16} className="text-blue-700" data-id="element-145" />;
      default:
        return <Rss size={16} className="text-gray-500" data-id="element-146" />;
    }
  };
  return <div className="border border-gray-200 rounded-lg p-3 bg-white hover:bg-[#EFF2F1]/50 transition-colors" data-id="element-147">
      <div className="flex items-center justify-between mb-2" data-id="element-148">
        <div className="flex items-center space-x-2" data-id="element-149">
          {getPlatformIcon(platform)}
          <span className="text-xs font-medium text-gray-900 capitalize" data-id="element-150">
            {platform}
          </span>
        </div>
        <span className="text-xs text-gray-500" data-id="element-151">{time}</span>
      </div>
      <p className="text-sm text-gray-700 mb-3" data-id="element-152">{content}</p>
      {bookCover && <div className="flex items-center space-x-2 mb-3 p-2 bg-[#EFF2F1] rounded border" data-id="element-153">
          <img src={bookCover.image} alt={bookCover.title} className="w-8 h-12 object-cover rounded" data-id="element-154" />
          <div className="flex-1 min-w-0" data-id="element-155">
            <p className="text-xs font-medium text-gray-900 truncate" data-id="element-156">
              {bookCover.title}
            </p>
            <div className="flex items-center space-x-1 text-xs text-gray-500" data-id="element-157">
              <BookOpen size={10} data-id="element-158" />
              <span data-id="element-159">New book</span>
            </div>
          </div>
        </div>}
      <div className="flex items-center justify-between" data-id="element-160">
        <div className="flex items-center space-x-4" data-id="element-161">
          <button className="flex items-center space-x-1 text-xs text-gray-500 hover:text-[#C6D6AB] transition-colors" data-id="element-162">
            <Heart size={14} data-id="element-163" />
            <span data-id="element-164">{likes}</span>
          </button>
          <button className="flex items-center space-x-1 text-xs text-gray-500 hover:text-[#7F9EA4] transition-colors" data-id="element-165">
            <MessageSquare size={14} data-id="element-166" />
            <span data-id="element-167">{comments}</span>
          </button>
        </div>
        <button className="text-xs text-gray-500 hover:text-[#376770] transition-colors" data-id="element-168">
          <Share2 size={14} data-id="element-169" />
        </button>
      </div>
    </div>;
}